import * as AuthHelper from './APIHelper';

export const PostGithubTicket = (payload) => {
    return AuthHelper.postResponse('/github/ticket', payload);
}